import {
  FaFacebook, FaFacebookF, FaGooglePlusG, FaInstagram, FaTelegramPlane, FaTwitter, FaYoutube,
} from 'react-icons/fa';

export const shareProduct = [
  {
    id: 's1',
    icon: <FaFacebookF />,
    url: 'https://facebook.com',
  },
  {
    id: 's2',
    icon: <FaTwitter />,
    url: 'https://twitter.com',
  },
  {
    id: 's3',
    icon: <FaTelegramPlane />,
    url: 'https://telegram.com',
  },
  {
    id: 's4',
    icon: <FaGooglePlusG />,
    url: 'https://google.com',
  },
];

export const socialMedia = [
  {
    id: 's1',
    icon: <FaFacebook />,
    url: 'https://facebook.com',
  },
  {
    id: 's2',
    icon: <FaInstagram />,
    url: 'https://instagram.com',
  },
  {
    id: 's3',
    icon: <FaYoutube />,
    url: 'https://youtube.com',
  },
];
